import * as React from "react";
import { BaseMedia } from "typings/media";
import { Icon, List } from "office-ui-fabric-react";
import { formatFilePath } from "~/util/media";

export interface Props
{
    files: BaseMedia[];
    selected?: string[];
    onItemClick: (type: string, id: string) => () => void;
}

export const mediaItemRender = ( item: BaseMedia, onClick?: () => void, className?: string, hideLabel?:boolean) =>
{
    let label = hideLabel || item.data.name === undefined ? undefined : item.data.name.value;
    let content = null;
    if (item.type === "folder")
    {
        content = <Icon iconName="FolderHorizontal"></Icon>;
    }
    else
    {
        if (item.type === "image")
        {
            const filePath: string = item.data.orginalFilePath.value;
            content = <img src={`${formatFilePath(filePath)}`} />;
        }

        if (item.type === "file")
        {
            const filePath: string = item.data.orginalFilePath.value;
            let iconName = "File";
            if (filePath.endsWith(".pdf"))
            {
                iconName = "PDF";
            }
            content = <Icon iconName={iconName}></Icon>;
        }

        if (item.type === "youtube")
        {
            if (item.data.youtubeid) 
            {
                content = <img src={`https://img.youtube.com/vi/${item.data.youtubeid.value}/default.jpg`} />;
                label = undefined;
            } 
            else 
            {
                content = <Icon iconName="FiYoutube"></Icon>;
            }
        }
    }
    
    const current:boolean = location.href.indexOf(item.id) !== -1 ? true : false;

    return (
        <a onClick={onClick} title={label || ""} className={`${className || ""} ${item.type} ${current ? " active" : ""}`}>
            {content}
            {label ? <h5>{label}</h5> : null}
        </a>
    );
};

class ListMediaFiles extends React.Component<Props>
{
    onRenderCell = (item: BaseMedia, index: number | undefined) =>
    {
        const { onItemClick, selected } = this.props;
        const onClick = onItemClick(item.type, item.id);
        
        const className = `item${selected && selected.indexOf(item.id) > -1 ? " selected" : ""}`;
        return mediaItemRender(item, onClick, className);
    }

    getItemCountForPage = () => this.props.files.length;

    render()
    {
        return <List
            items={this.props.files}
            getItemCountForPage={this.getItemCountForPage}
            onRenderCell={this.onRenderCell}
        />;
    }
}

export default ListMediaFiles;


// WEBPACK FOOTER //
// ./src/components/media/ListMediaFiles.tsx